/**
 *
 * Asynchronously loads the component for Men004
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
